import React, { useContext } from "react"
import Grid from "../shared/grid"
import { useStaticQuery, graphql } from "gatsby"
import {
  BackgroundContainer,
  SectionContainer,
  Title,
  Description,
  LinkContainer,
  Background,
} from "./careers-promo.style"
import Link from "../shared/link"
import { UIContext } from "../shared/layout"

export default function CareersPromo() {
  const query = useStaticQuery(graphql`
    query {
      wonderlandLg: file(
        relativePath: { eq: "4_COMPANY/About/next_challenge_nogradient.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wonderlandSm: file(
        relativePath: {
          eq: "4_COMPANY/About/next_challenge_mobile_nogradient.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const {
    state: { breakpoint },
  } = useContext(UIContext)

  return (
    <SectionContainer>
      <Grid>
        <Title>Looking for your next challenge?</Title>
        <Description>
          We’re always looking to grow the Mappedin team.
          <br /> See our open roles or get in touch to explore your next career
          move.
        </Description>
        <LinkContainer>
          <Link href="/careers/">Explore Our Careers</Link>
        </LinkContainer>
        <BackgroundContainer>
          <Background
            imgStyle={{ objectFit: "cover" }}
            fluid={
              breakpoint === "sm"
                ? query.wonderlandSm.childImageSharp.fluid
                : query.wonderlandLg.childImageSharp.fluid
            }
          />
        </BackgroundContainer>
      </Grid>
    </SectionContainer>
  )
}
